export function buildDocumentTitle({
  pageTitle = "",
  roleLabel = ""
} = {}) {
  const normalizedPageTitle = String(pageTitle || "").trim();
  const normalizedRoleLabel = String(roleLabel || "").trim();

  if (normalizedPageTitle && normalizedRoleLabel) {
    return `${normalizedPageTitle} - ${normalizedRoleLabel}`;
  }

  if (normalizedRoleLabel) {
    return `教材征订系统 - ${normalizedRoleLabel}`;
  }

  return "教材征订系统";
}
